import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Button, Col, Flex, Form, Input, Radio, Row } from "antd";

export default function RenderRadio(props) {
	const {
		namePath = [],
		form_question_options = [],
		required = false,
		question = null,
		description = null,
		add_another = false,
	} = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	const [inputs, setInputs] = useState(add_another ? [{ id: 0 }] : []);

	const handleAddAnother = () => {
		setInputs((prev) => [...prev, { id: prev.length }]);
	};

	const renderRadioField = (fieldName) => (
		<Form.Item shouldUpdate noStyle>
			{({ getFieldValue }) => {
				let selectedValue = getFieldValue(fieldName);
				let findOther = form_question_options.find((x) => x.is_other)?.option;

				return (
					<Form.Item
						name={fieldName}
						rules={[
							{
								required: required ? true : false,
								message: "This field is required!",
							},
						]}
					>
						<Radio.Group size="large">
							<Flex vertical="vertical">
								{form_question_options.filter((x) => !x.is_other).length
									? form_question_options.map((item, index) => {
											return (
												<Radio key={`${item.id}-${index}`} value={item.option}>
													<Flex align="baseline" gap={5}>
														{item.option}
														{item.is_other && selectedValue === findOther ? (
															<Form.Item name={`${fieldName}_other`} noStyle>
																<Input placeholder="Please specify" />
															</Form.Item>
														) : null}
													</Flex>
												</Radio>
											);
									  })
									: null}
							</Flex>
						</Radio.Group>
					</Form.Item>
				);
			}}
		</Form.Item>
	);

	// If add_another is enabled, render for each input set
	if (add_another) {
		return (
			<>
				{inputs.map((input, idx) => (
					<Col
						xs={24}
						sm={24}
						md={24}
						lg={24}
						xl={24}
						key={`input_set_${input.id}`}
					>
						<Row>
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<div
									className="quill-output question"
									dangerouslySetInnerHTML={{
										__html: question,
									}}
								/>
								{description && (
									<div className="description">{description}</div>
								)}
							</Col>
						</Row>
						<Row>
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								{renderRadioField(`${newNamePath}_set_${idx}`)}
							</Col>
						</Row>
					</Col>
				))}

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Button
						type="link"
						className="w-auto h-auto p-0"
						icon={<FontAwesomeIcon icon={faPlus} />}
						onClick={handleAddAnother}
					>
						Add Another
					</Button>
				</Col>
			</>
		);
	}

	return (
		<Row>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<div
					className="quill-output question"
					dangerouslySetInnerHTML={{
						__html: question,
					}}
				/>
				{description && <div className="description">{description}</div>}
			</Col>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				{renderRadioField(newNamePath)}
			</Col>
		</Row>
	);
}
